import { translateLabel, useSettings } from "@repo/ui";
import { getFullName } from "@repo/utils";

import {
  type CoWorkerCalendarItem,
  isCoWorkerScheduleActivity,
} from "../types";
import { ScheduleActivityTitle } from "./ScheduleActivityTitle";

interface CalendarBlockTextProps {
  item: CoWorkerCalendarItem;
}

export const CalendarBlockText = ({ item }: CalendarBlockTextProps) => {
  const { general, customerMode } = useSettings();
  const { customer, title } = item;
  const customerName = getFullName(
    customer?.firstName,
    customer?.lastName,
    general?.localization?.reverse_names,
    customerMode
  );

  if (isCoWorkerScheduleActivity(item)) {
    return <ScheduleActivityTitle item={item} />;
  }
  if (customer?.firstName && customer?.lastName) {
    return <>{`${customerName} - ${title}`}</>;
  }
  return <>{translateLabel(title)}</>;
};
